import React, { Component } from 'react';
import { API_CODY_URL } from '@appblocks/frontend/client/utils';

interface TibbitProps {
    descriptions: Array<string>;
    lines: Array<any>;
    tibbit: string;
    mode: string;
    // eslint-disable-next-line react/no-unused-prop-types
    num: string;
    // eslint-disable-next-line react/no-unused-prop-types
    category: string;
}

export default class Tibbit_base extends Component<TibbitProps> {
    width: number;

    height: number;

    constructor(props: TibbitProps) {
        super(props);
        this.width = 100;
        this.height = 100;
    }

    renderDescriptions() {
        return this.props.descriptions.map((line, index) => (
            <tspan
                key={index}
                x={0}
                y={6.803 * index}
            >
                {line.toUpperCase()}
            </tspan>
        ));
    }

    renderArrow(direction: string, leftArrow: string, rightArrow: string) {
        switch (direction) {
            case 'left':
                return <polygon points={leftArrow} fill="#fff" />;
            case 'right':
                return <polygon points={rightArrow} fill="#fff" />;
            default:
                return null;
        }
    }

    renderLines() {
        return this.props.lines.map((line, i) => {
            if (!line.requirement) {
                return null;
            }
            let divider = 0;
            if (i >= 4) {
                divider = 10;
            }
            const x = this.width - 22;
            const y = divider + 7 + i * 10;
            const leftArrow = `${x} ${y}, ${x + 5}  ${y + 2.5} , ${x} ${y + 5} `;
            const rightArrow = `${x + 5} ${y}, ${x}  ${y + 2.5} , ${x + 5} ${y + 5} `;
            return (
                <g key={i}>
                    {!line.direction
                        ? <rect x={this.width - 22} y={divider + 7 + i * 10} width="5" height="5" stroke="#fff" fill="#aaa" />
                        : this.renderArrow(line.direction, leftArrow, rightArrow)
                    }
                    <text x={this.width - 25} y={divider + 12 + i * 10} fontSize="6" fill="#fff" textAnchor="end">{line.id}</text>
                </g>
            );
        });
    }

    renderWiring() {
        let tibbitId = this.props.tibbit;
        if (tibbitId === undefined) {
            return null;
        }
        if (tibbitId.length === 1) {
            tibbitId = `0${tibbitId.toString()}`;
        }
        if (this.props.mode === 'wiring') {
            return (
                <image xlinkHref={`/static/tibbit-wiring/${this.props.tibbit}.svg`} />
            );
        }
        return null;
    }
}
